<template>
  <div class="container-fluid">
    <page-header
      :page="page"
      has-return
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />

    <div class="row mx-0 bg-secondary-1">
      <div class="col-md-2 col-sm-12 pr-4 pt-4">
        <ValidationObserver ref="resumeRef" tag="form">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="resumeType"
              fieldkey="id"
              fieldname="name"
              :options="resumeTypes"
              custom-error-msg="Es requerido seleccionar el tipo de resumen."
              :error="errors[0]"
              placeholder="Tipo de Resumen"
            />
          </ValidationProvider>
        </ValidationObserver>
      </div>
      <div class="col-md-2 col-sm-12 p-4 ">
        <action-button
          i="fa fa-arrow-circle-right"
          text="Generar Resumen"
          variant="success ml-4"
          @click="generateResume()"
        />
      </div>
    </div>
    <div v-if="showSaee">
      <SaeeRow v-for="item in allSaee" :key="item.id" :value="item" />
    </div>
    <div v-if="showSchoolInfo">
      <SchoolInfoRow
        v-for="item in allAssistants"
        :value="item"
        :key="item.id"
      />
    </div>
    <div v-if="showTeacherInfo">
      <TeacherInfo :value="teacherData" />
    </div>
    <custom-result-not-found v-else text="No hay Información Disponible." />
  </div>
</template>

<script>
import PageHeader from "PageHeader";
import CustomResultNotFound from "custom-result-not-found";
import ActionButton from "ActionButton";
import CustomDropDown from "custom-drop-down";
import SaeeRow from "./components/SaeeRow.vue";
import SchoolInfoRow from "./components/SchoolInfoRow.vue";
import TeacherInfo from "./components/TeacherInfo.vue";
import {
  getResumeTypes,
  getSaeeByRequest,
  getSaeeSchoolByRequest,
  getSaeeTeacherByRequest
} from "@/modules/human-resources/api";
import { resumeTypeCodes } from "@/utils/constants/hrrequest/resumeTypeCodes";
resumeTypeCodes;
export default {
  name: "ResumeRequests",
  components: {
    PageHeader,
    CustomResultNotFound,
    CustomDropDown,
    SaeeRow,
    SchoolInfoRow,
    TeacherInfo,
    ActionButton
  },
  data() {
    return {
      requestId: null,
      resumeTypes: [],
      resumeType: null,
      allSaee: [],
      allAssistants: [],
      teacherData: null
    };
  },
  computed: {
    page() {
      return {
        icon: "fas fa-users-class",
        title: "Resumen",
        routes: ["Inicio", "Recursos Humanos", "Personal Irregular", "Resumen"]
      };
    },
    resultNoFound() {
      return !this.allSaee.length;
    },
    showSaee() {
      return (
        this.resumeType?.id == resumeTypeCodes.Estudiante &&
        this.allSaee.length > 0
      );
    },
    showSchoolInfo() {
      return (
        this.resumeType?.id == resumeTypeCodes.Escuela &&
        this.allAssistants.length > 0
      );
    },
    showTeacherInfo() {
      return (
        this.resumeType?.id == resumeTypeCodes.Maestro &&
        this.teacherData != null
      );
    }
  },
  methods: {
    async getResumeTypesList() {
      const { data } = await getResumeTypes();
      this.resumeTypes = data;
    },
    async generateResume() {
      const isValid = await this.$refs.resumeRef.validate();
      if (!isValid) return;
      switch (this.resumeType.id) {
        case resumeTypeCodes.Estudiante:
          const { data } = await getSaeeByRequest(this.requestId);
          this.allSaee = data;
          break;
        case resumeTypeCodes.Escuela:
          const { data: assistantData } = await getSaeeSchoolByRequest(
            this.requestId
          );
          this.allAssistants = assistantData;
          break;
        case resumeTypeCodes.Maestro:
          const { data: teacherData } = await getSaeeTeacherByRequest(
            this.requestId
          );
          this.teacherData = teacherData;
          break;
      }
    }
  },
  mounted() {
    this.getResumeTypesList();
    this.requestId = this.$route.params.id;
  }
};
</script>
